import { render } from "./CompanySelector.vue?vue&type=template&id=3a5c792b&scoped=true"
import script from "./CompanySelector.vue?vue&type=script&lang=js"
export * from "./CompanySelector.vue?vue&type=script&lang=js"

import "./CompanySelector.vue?vue&type=style&index=0&id=3a5c792b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5c792b"]])

export default __exports__